import { render, staticRenderFns } from "./UsersNotificationsCreate.vue?vue&type=template&id=9c7f3b08&scoped=true"
import script from "./UsersNotificationsCreate.vue?vue&type=script&lang=js"
export * from "./UsersNotificationsCreate.vue?vue&type=script&lang=js"
import style0 from "./UsersNotificationsCreate.vue?vue&type=style&index=0&id=9c7f3b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7f3b08",
  null
  
)

export default component.exports